import { useEffect } from "react";

import { useLoyalty } from "@ui/hooks/useLoyalty";

import { getUser, LoyaltyApi } from "@jti/rest-api";

import { useHeaderContext } from "../../context";

import styles from "./PointsDisplay.module.scss";

export type PointsDisplayProps = {
  loyaltyCurrency: string;
};

export const PointsDisplay = ({ loyaltyCurrency }: PointsDisplayProps) => {
  const { loyaltyPoints, isLoyaltyActive, setLoyaltyData } = useHeaderContext();
  const isLoyaltyVerifiedSuccessfully = useLoyalty();

  useEffect(() => {
    const user = getUser();

    const getLoyaltyData = async () => {
      try {
        const [tier, points] = await Promise.all([
          LoyaltyApi.init().getUserTier(user.uuid ?? "", user.ciam_token ?? ""),
          LoyaltyApi.init().getPoints(user.uuid ?? "", user.ciam_token ?? ""),
        ]);
        setLoyaltyData({
          userTier: tier.name,
          points: points.points,
          isActive: isLoyaltyVerifiedSuccessfully,
        });
      } catch (error) {
        console.error("Error fetching loyalty data:", error);
      }
    };

    if (isLoyaltyVerifiedSuccessfully && user.uuid && user.ciam_token) {
      getLoyaltyData();
    } else {
      setLoyaltyData((prevState) => ({
        ...prevState,
        isActive: isLoyaltyVerifiedSuccessfully,
      }));
    }
  }, [isLoyaltyVerifiedSuccessfully, setLoyaltyData]);

  if (!isLoyaltyActive || loyaltyPoints === null) {
    return null;
  }

  return (
    <div className={styles.pointsDisplay}>
      <span className={styles.points}>{loyaltyPoints}</span>
      <span className={styles.currency}>{loyaltyCurrency}</span>
    </div>
  );
};
